<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
       {{'SAVE_CONFIRMATION' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]="null"></button>
</div>
<mat-dialog-content> 
    <mat-icon>help</mat-icon>
    {{'SAVE_CHANGES_MESSAGE' | translate }} {{ data.selectionName }}?
</mat-dialog-content>
<mat-dialog-actions align="end">
   <button class="openCloseBtn" mat-raised-button color="primary" [mat-dialog-close]="constants.YES">{{'YES' | translate}}</button>
   <button class="openCloseBtn" mat-raised-button color="primary" [mat-dialog-close]="constants.NO">{{'NO' | translate}}</button>
   @if (data.showCancelButton) {
    <button class="openCloseBtn" mat-raised-button color="warn" [mat-dialog-close]="constants.CANCEL">{{'CANCEL' | translate}}</button>
   }
</mat-dialog-actions>
